import React, { forwardRef } from "react";
import { useState } from "react";

import { ColorDot, Container, Row } from "./style";

import Popper from "../../../general/Popper";

const ColorPalet = ({
  isOpen,
  onClose,
  anchorRef,
  handleNoteColor,
  handleTextColor,
  type,
}) => {
  const handleClose = onClose();
  const [markerPosition, setMarkerPosition] = useState({
    pos: `50%`,
    above: true,
  });
  let rect = { width: 0, height: 0 };
  if (anchorRef && anchorRef.current) {
    rect = anchorRef.current.getBoundingClientRect();
  }

  const handleColorClick = (color) => {
    if (type === "NoteColor") {
      handleNoteColor(color);
    } else {
      handleTextColor(color);
    }
  };

  const simplifiedColors1 = ["#F00", "#F80", "#FF0", "#8F0", "#0F0"];
  const simplifiedColors2 = ["#0F8", "#0FF", "#08F", "#00F", "#80F"];
  const simplifiedColors3 = ["#FFF", "#BBB", "#888", "#444", "#000"];

  const PastelColors2 = [
    "rgba(153, 255, 207, 1.0)",
    "rgba(153, 255, 255, 1.0)",
    "rgba(153, 207, 255, 1.0)",
    "rgba(153, 153, 255, 1.0)",
    "rgba(207, 153, 255, 1.0)",
  ];

  const PastelColors1 = [
    "rgba(255, 153, 153, 1.0)", // Vermelho pastel
    "rgba(255, 207, 153, 1.0)", // Laranja pastel
    "rgba(255, 255, 153, 1.0)", // Amarelo pastel
    "rgba(207, 255, 153, 1.0)", // Amarelo-Verde pastel
    "rgba(153, 255, 153, 1.0)", // Verde pastel]
  ];

  const row1 = type === "NoteColor" ? PastelColors1 : simplifiedColors1;
  const row2 = type === "NoteColor" ? PastelColors2 : simplifiedColors2;

  return (
    <Popper
      isOpen={isOpen}
      onClose={handleClose}
      anchorRef={anchorRef}
      width={175}
      height={90}
      setMarkerPosition={setMarkerPosition}
      markerSize={14}
    >
      <Container
        markPosition={markerPosition.pos}
        isAbove={markerPosition.above}
        width={rect.width}
      >
        <Row>
          {row1.map((color) => (
            <ColorDot
              key={color}
              onClick={() => handleColorClick(color)}
              color={color}
            />
          ))}
        </Row>
        <Row>
          {row2.map((color) => (
            <ColorDot
              key={color}
              onClick={() => handleColorClick(color)}
              color={color}
            />
          ))}
        </Row>
        <Row>
          {simplifiedColors3.map((color) => (
            <ColorDot
              key={color}
              onClick={() => handleColorClick(color)}
              color={color}
            />
          ))}
        </Row>
      </Container>
    </Popper>
  );
};

export default ColorPalet;
